export const settings = {
    url: "https://appmagdalena.net", //process.env.REACT_APP_DEFAULT_URL ,
    mpbox: 'pk.eyJ1IjoianBhbHRhaG9uYSIsImEiOiJja2Qxb3FpMnQwNWtmMnhueDFoeWNqdXA0In0.GpHphk05qXvdmu0W2iuPig'
}